import React, { useState, useEffect } from "react"
import styled from "styled-components"

import { Row, Col, Card, InputGroup, FormControl } from "react-bootstrap"
import Parser from "html-react-parser"
import Image from "gatsby-image"

export let OtherSection = props => {
  return (
    <>
      <section style={{ paddingBottom: "4rem", paddingTop: "4rem" }}>
        <RowTecho>
          <h1>
            {" "}
            <b>{props.titleSection} </b>
          </h1>
        </RowTecho>
        <RowTecho className="row justify-content-md-center">
          <Col
            xl={4}
            lg={4}
            md={{ span: 6 }}
            sm={6}
            xs={8}
            style={{ marginBottom: "2rem" }}
          >
            <Image fluid={props.imgOne} alt={props.nameSpeakerOne}></Image>
          </Col>

          <Col
            xl={6}
            lg={8}
            md={{ span: 8 }}
            sm={8}
            className="align-self-center"
          >
            <RowText className=" align-items-center">
              <p style={{ marginBottom: "2rem" }}>
                {Parser(props.contentSection)}
              </p>
              {props.contentSectionTwo && (
                <div className="row align-items-center">
                  <Col xl={3} lg={3} xs={4}>
                    <Image
                      fluid={props.fluidSpeakerOne}
                      style={{ maxWidth: "100px" }}
                      alt={props.nameSpeakerOne}
                    ></Image>
                  </Col>
                  <Col xl={6} lg={6} xs={8}>
                    <p>
                      <b>{props.nameSpeakerOne} </b>
                    </p>
                    <p style={{ fontSize: "0.9rem" }}>
                      {Parser(props.jobSpeakerOne)}
                    </p>
                  </Col>
                </div>
              )}
            </RowText>
          </Col>
        </RowTecho>
        {/*  SECCION PERSONA 2 */}
        {props.contentSectionTwo && (
          <RowTecho className="row justify-content-md-center">
            <Col
              xl={4}
              lg={4}
              md={{ span: 6 }}
              sm={6}
              xs={8}
              style={{ marginBottom: "2rem" }}
            >
              <Image fluid={props.imgTwo} alt={props.nameSpeakerTwo}></Image>
            </Col>

            <Col
              xl={6}
              lg={8}
              md={{ span: 8 }}
              sm={8}
              className="align-self-center"
            >
              <RowText className=" align-items-center">
                <p style={{ marginBottom: "2rem" }}>
                  {Parser(props.contentSectionTwo)}
                </p>
                <div className="row align-items-center">
                  <Col xl={3} lg={3} xs={4}>
                    <Image
                      fluid={props.fluidSpeakerTwo}
                      style={{ maxWidth: "100px" }}
                      alt={props.nameSpeakerTwo}
                    ></Image>
                  </Col>
                  <Col xl={6} lg={6} xs={8}>
                    <p>
                      <b>{props.nameSpeakerTwo} </b>
                    </p>
                    <p style={{ fontSize: "0.9rem" }}>
                      {Parser(props.jobSpeakerTwo)}
                    </p>
                  </Col>
                </div>
              </RowText>
            </Col>
          </RowTecho>
        )}
      </section>
    </>
  )
}

const RowTecho = styled.div`
  padding-left: 200px;
  padding-right: 200px;
  margin-top: 3rem;
  justify-content: center !important;
  text-align: center;
  img {
    max-width: 400px;
  }
  h1 {
    font-size: 3rem;
    text-align: center !important;
    @media (max-width: 600px) {
      font-size: 2rem;
    }
  }

  @media (max-width: 1000px) {
    padding-left: 20px;
    padding-right: 20px;
  }
  @media (max-width: 502px) {
    padding-left: 20px;
    padding-right: 20px;
  }
`

const RowText = styled.div`
  margin-right: auto;
  margin-left: auto;
  justify-content: left !important;
  text-align: left !important;
  width: 100%;

  p {
    font-size: 1.2rem;

    font-family: "Inter", system-ui;
  }

  h2 {
    font-family: "Inter", system-ui;
    font-size: 1.5rem !important;
  }
  a {
    color: white;
    font-family: "Inter", system-ui;
    font-size: 1.5rem !important;
    font-weight: bold;
  }
  li {
    font-size: 1.2rem !important;
    font-weight: bold;
    font-family: "Inter", system-ui;
    margin-bottom: 1rem !important;
    margin-top: 1rem !important;
  }
  @media (max-width: 500px) {
    li {
      font-size: 1rem !important;
    }
  }
`

export default OtherSection
